import { BreadcrumbItem } from "@interfaces/components/breadcrumb.interface";
import Link from "next/link";

interface Props {
  breadcrumbItems: BreadcrumbItem[];
}

const Breadcrumb = ({ breadcrumbItems }: Props) => {
  return (
    <nav aria-label="breadcrumb">
      <ol className="breadcrumb">
        {breadcrumbItems.map(({ name, link }, idx) => (
          <li
            key={idx}
            className={`breadcrumb-item ${
              breadcrumbItems.length === idx + 1 && "active"
            }`}
          >
            {link === undefined ? (
              <>{name}</>
            ) : (
              <Link href={link}>
                <a>{name}</a>
              </Link>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
};

export default Breadcrumb;
